
import UserResults from '../components/users/UserResults'
import UserSearch from '../components/users/UserSearch'

function Home() {
  return (
    <>
      <UserResults />
      <UserSearch />

    </>
  )
}

export default Home
